import { inject, Injectable, CSP_NONCE } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CspConfigService {

  ngCspNonce = inject(CSP_NONCE, { optional: true });

  constructor() {
  }

  getCspNonce(): string | undefined {
    return this.ngCspNonce ? this.ngCspNonce : undefined;
  }

}
